import React, { useMemo } from "react";

import { ITableColumnConfig, ITableDataParams } from "./types";

export function useColumnsConfig(columns: ITableColumnConfig[]) {
  return useMemo(() => {
    return initColumns(columns);
  }, [columns]);
}

export function initColumns(columns: ITableColumnConfig[]) {
  return columns.map((column) => {
    return {
      headerValueGetter: defaultHeaderValueGetter,
      headerCellRenderer: defaultHeaderCellRenderer,
      valueGetter: defaultValueGetter,
      cellRenderer: defaultCellRenderer,
      ...column,
    };
  });
}

export function defaultValueGetter({ rowData, column }: ITableDataParams) {
  return String(rowData[column.field]);
}

export function defaultCellRenderer({ rowData, column }: ITableDataParams) {
  if (!column.valueGetter) {
    throw new Error("valueGetter should be defined in the column config");
  }

  const value = String(column.valueGetter({ rowData, column }));
  return (
    <div className="ams-table__cell-content" title={value}>
      {value}
    </div>
  );
}

export function defaultHeaderValueGetter({ column }: ITableDataParams) {
  return String(column.headerName);
}

export function defaultHeaderCellRenderer({ column }: ITableDataParams) {
  if (!column.headerValueGetter) {
    throw new Error("headerValueGetter should be defined in the column config");
  }

  const value = String(column.headerValueGetter({ column }));
  return (
    <div className="ams-table__cell-content" title={value}>
      {value}
    </div>
  );
}

export function getKey(...keys: (string | number)[]) {
  return keys.join("-");
}
